const acServiceDescriptions = [
  {
    aliases: ["ac installation"],
    text:
      "Oh yes home solution provides professional best AC installation services handled by certified background-verified technicians dispatched directly to your doorstep. Our Split AC installation (upto 2 tons) covers indoor and unit mounting, copper pipe fitting, electrical connection and post installation test run - ensuring your AC runs at peak efficiency from day one.",
  },
  {
    aliases: ["ac uninstallation", "ac unistallation"],
    text:
      "Get the best AC uninstallation service at your doorstep with Oh Yes Home Solutions — your reliable partner in home maintenance. Our certified, background-verified AC technicians safely and carefully remove your split or window AC unit — both indoor and outdoor — without causing any damage to your walls or fittings. Whether you're shifting to a new home, upgrading your AC, or replacing an old unit, we handle the entire removal process with precision and care. From disconnecting electrical connections to dismounting the indoor and outdoor units, every step is carried out by trained professionals ensuring zero damage and complete safety. Base price may vary based on the chosen service partner and the specific requirements of your uninstallation. Book today and get your AC uninstalled within few hours, anywhere across your city — fast, safe, and hassle-free.",
  },
  {
    aliases: ["ac service", "a c service"],
    text:
      "Oh yes Home solution provides you with the most relaible and professional Ac service near you -keep your home cool ,fresh and stress free all year long .As part of smart home maintenance ,our certified technicians deliver a complete air conditioning service ,restoring peak performance and maximizing energy effiency no delays and no hassle -every service carried out by experts and completed within few hours of your booking,right at your door step .Say good bye to warm rooms and sky- high electricity bills,Book your service today-comfort is just one tap away",
  },
  {
    aliases: ["ac repair", "a c repair", "ac repairing"],
    text:
      "Oh yes, Home Solutions provides the best AC repairing service to get your cooling system back to perfect working condition — fast, reliable, and affordable. A faulty AC shouldn't disrupt your comfort, and as part of trusted home maintenance, our skilled technicians accurately diagnose and fix any AC issue with precision and care. No long waiting periods — every repair is handled by certified experts and right at your doorstep. From unusual noises to poor cooling, we've got every problem covered.. Restoring your AC's performance has never been easier or more affordable. Don't suffer the heat",
  },
  {
    aliases: ["ac jet wash service", "jet wash ac service"],
    text:
      "Oh yes, Home Solutions provides the best AC Jet Wash service to breathe new life into your air conditioner — deeply cleaned, powerfully restored, and running like brand new. If your AC is making strange noises, blowing weak cool air, or simply hasn't been serviced in a while, a professional jet wash is exactly what it needs. As part of complete home maintenance, our certified technicians use high-pressure water jets and specialised cleaning agents to flush out every trace of dust, mould, and buildup from deep inside your unit. The result? Stronger cooling, fresher air, and lower electricity bills — all in one service. Fast and hassle-free,",
  },
  {
    aliases: ["premium ac jet wash service", "premium jet wash ac service"],
    text:
      "Oh yes, Home Solutions provides the No.1 premium Jet Wash AC service — redefining what a truly clean AC feels like. Most services clean the surface. Ours goes all the way in. Our expert technicians fully uninstall your AC and deploy advanced high-pressure technology to deep clean every coil, fin, and hidden internal component from the inside out. As a core part of professional home maintenance, this premium service eliminates all dust, mould, bacteria, and stubborn buildup — delivering ice-cold cooling, whisper-clean airflow, and noticeably lower electricity bills from day one. No shortcuts, no compromises ,feel the difference today!",
  },
];

function normalizeTitle(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\ba c\b/g, "ac")
    .replace(/\s+/g, " ")
    .trim();
}

export function getAcServiceDescription(title) {
  const normalized = normalizeTitle(title);
  const match = acServiceDescriptions.find((item) =>
    item.aliases.some((alias) => normalizeTitle(alias) === normalized),
  );

  return match?.text || null;
}

export function enrichAcServiceContent(service) {
  const text = getAcServiceDescription(service?.title);
  if (!text) return service;

  const existingDescription =
    service.description && typeof service.description === "object"
      ? service.description
      : {};

  return {
    ...service,
    description: {
      ...existingDescription,
      text,
    },
  };
}
